import { render } from "./Main.vue?vue&type=template&id=35ddba9d"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "@vueform/slider/themes/default.css?vue&type=style&index=0&lang=css"
import "./Main.vue?vue&type=style&index=1&id=35ddba9d&lang=css"
script.render = render

export default script